/**
 * Р46: одно уведомление, когда обработана ВСЯ база знаний — на любой странице
 * кабинета. Здесь — список ассистентов, у которых что-то обрабатывается, и id
 * источников, которые мы видели «в обработке». Хранится в localStorage, чтобы
 * уведомление пришло и после перезагрузки страницы.
 */
const KEY = 'richat.kbWatch';
const EVT = 'richat-kbwatch';

/** aid → источники, которые видели «в обработке», и когда добавили последний. */
export type KbWatch = Record<string, { ids: string[]; at: number }>;

export function readWatch(): KbWatch {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || '{}') as Record<string, unknown>;
    const out: KbWatch = {};
    for (const [aid, e] of Object.entries(v ?? {})) {
      const x = e as { ids?: unknown; at?: unknown };
      if (Array.isArray(x?.ids)) out[aid] = { ids: x.ids.map(String), at: Number(x.at) || 0 };
    }
    return out;
  } catch {
    return {};
  }
}

function write(w: KbWatch) {
  try {
    localStorage.setItem(KEY, JSON.stringify(w));
  } catch {
    /* приватный режим — уведомление будет только до перезагрузки */
  }
  window.dispatchEvent(new Event(EVT));
}

/** Запомнить, что у ассистента обрабатываются эти источники. */
export function watchKb(aid: string, ids: string[]) {
  if (!aid || !ids.length) return;
  const w = readWatch();
  const cur = new Set(w[aid]?.ids ?? []);
  const before = cur.size;
  ids.forEach((id) => cur.add(id));
  if (cur.size === before && w[aid]) return;
  write({ ...w, [aid]: { ids: [...cur], at: Date.now() } });
}

export function unwatchKb(aid: string) {
  const w = readWatch();
  if (!(aid in w)) return;
  delete w[aid];
  write(w);
}

export function onWatchChange(cb: () => void) {
  const h = (e: Event) => {
    if (e.type === 'storage' && (e as StorageEvent).key !== KEY) return;
    cb();
  };
  window.addEventListener(EVT, h);
  window.addEventListener('storage', h);
  return () => {
    window.removeEventListener(EVT, h);
    window.removeEventListener('storage', h);
  };
}
